module.exports = __webpack_public_path__ + "static/media/temperature.d06a58eb.svg";